import React from 'react';
import { useWatch } from 'react-hook-form';

import FormDraftProvider from 'components/SankeyForm/FormDraftProvider';
import { CanvasSizeEnum } from 'generated-api';
import Field from 'ui/Field';
import { HStack, VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

import { useAppEnvironmentContext } from '../../../contexts/appEnvironmentContext';
import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';
import { FormNumberInput, FormSlider } from '../../SankeyForm';
import CanvasSizeSelect from '../CanvasSizeSelect';

const LayoutContent: React.FC = () => {
  const { appEnvironment } = useAppEnvironmentContext();

  const { form } = useSankeyFormContext();
  const [canvasSize] = useWatch({
    control: form.control,
    name: ['canvas_size'],
  });

  return (
    <VStack alignItems="stretch" gap={1}>
      {/*
        Only let web app users change the canvas size - the Office users shouldn't
        care about it since they can't export anything yet.
      */}
      {appEnvironment === 'web' && (
        <VStack alignItems="flex-start" mb={3}>
          <Field label="Canvas size" fontSize="xs">
            <CanvasSizeSelect />
          </Field>
          {canvasSize === CanvasSizeEnum.CUSTOM && (
            // Lift FormDraftProvider in hierarchy once it works with CanvasSizeSelect
            <FormDraftProvider>
              <HStack gap={2}>
                <FormNumberInput field="canvas_width" maxW="80px" size="sm" />
                <Text fontSize="xl">×</Text>
                <FormNumberInput field="canvas_height" maxW="80px" size="sm" />
                <Text fontSize="sm">pixels</Text>
              </HStack>
            </FormDraftProvider>
          )}
        </VStack>
      )}
      <FormSlider label="Node width" field="node_width" />
      <FormSlider label="Node height" field="node_height" />
      <FormSlider label="Node spacing" field="node_spacing" />
    </VStack>
  );
};

export default LayoutContent;
